/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  configureAPUAPI.ts
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Deepthi Bachu (E844276)
 *
 * @Date	     : Oct 17, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Oct 23, 2019
 * Description   : ASDS-115
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Nov 1st, 2019
 * Description   : updated the code for ASDS-586
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Nov 4th, 2019
 * Description   : updated the code for ASDS-407
 *
 * By             : H422337
 * On             : Sep 24,2020
 * Description    : ASDS-3026 APU enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Sep 23, 2020
 * Description   : ASDS - 3020 - UI Enhancements for Phase - II
 *
 * By             : H422337
 * On             : Sep 25,2020
 * Description    : ASDS-3028 APU enhancements as part of phase-2
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 ******************************************************************************/
import API from './api';
import { CheckoutServiceURL } from "../constants/checkout-constants";

class ConfigureAPUAPI {
    static async getAircraftOEM(productId: any): Promise<any> {
        const response = await API.get(`${CheckoutServiceURL.GET_AIRCRAFT_OEM}${productId}`);
        return response;
    }

    static async getContractDetails(soldTo: any, modelNo: any): Promise<any> {
        const response = await API.get(`${CheckoutServiceURL.GET_CONTRACT_DETAILS}`, { params: {'soldTo': soldTo, 'modelNo': modelNo}});
        return response;
    }

    static async validateServiceOrder(serviceOrders: any): Promise<any>{
        const response = await API.post(`${CheckoutServiceURL.SERVICE_ORDER_URL}`, serviceOrders);
        return response;
}

    static async getPurchaseOrderDetails(soldTo: string): Promise<any> {
        const response = await API.get(`${CheckoutServiceURL.PURCHASE_ORDER_URL}${soldTo}`);
        return response;
    }
}

export default ConfigureAPUAPI;